import { OrganizationUserRole } from '@shared/types';
import { useSelector } from 'react-redux';
import { getActiveOrganizationId } from '@/reducers/ui/organizationsUiReducer';
import useOrganizationUsers from './useOrganizationUsers';

export default function useOrganizationUsersByRole(role: OrganizationUserRole) {
  const activeOrganizationId = useSelector(getActiveOrganizationId);

  return useOrganizationUsers(activeOrganizationId, {
    enabled: !!activeOrganizationId,
    select: users => users?.filter(user => user.role === role)
  });
}
